module.exports = __webpack_public_path__ + "static/media/icn-smiley.de6f9726.svg";